"use client";

import { createContext, use, type ReactNode } from "react";

const FormPreloadStatusContext = createContext(false);

export function FormPreloadStatusProvider({
  pending,
  children,
}: {
  pending: boolean;
  children: ReactNode;
}) {
  return (
    <FormPreloadStatusContext.Provider value={pending}>
      {children}
    </FormPreloadStatusContext.Provider>
  );
}

export function useFormPreloadPending() {
  return use(FormPreloadStatusContext);
}
